// @ts-nocheck (temporary disabled, TODO - XH-53327)
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { IconData } from './types';
import AddVideo from '../../sprite-svg/add-video.svg';
import Alert from '../../sprite-svg/alert.svg';
import AppearanceMobile from '../../sprite-svg/appearance-mobile.svg';
import ArrowDownFilled from '../../sprite-svg/arrow-down-filled.svg';
import ArrowDownLong from '../../sprite-svg/arrow-down-long.svg';
import ArrowDownShort from '../../sprite-svg/arrow-down-short.svg';
import Awards from '../../sprite-svg/awards.svg';
import BigThumbs from '../../sprite-svg/big-thumbs.svg';
import BigThumbsDisabled from '../../sprite-svg/big-thumbs-disabled.svg';
import Bisexual from '../../sprite-svg/bisexual.svg';
import Bookmark from '../../sprite-svg/bookmark.svg';
import BurgerMenu from '../../sprite-svg/burger-menu.svg';
import Calendar from '../../sprite-svg/calendar.svg';
import Call from '../../sprite-svg/call.svg';
import Categories from '../../sprite-svg/categories.svg';
import Check from '../../sprite-svg/check.svg';
import Clear from '../../sprite-svg/clear.svg';
import Close from '../../sprite-svg/close.svg';
import CloseSmall from '../../sprite-svg/close-small.svg';
import Coins from '../../sprite-svg/coins.svg';
import Comments from '../../sprite-svg/comments.svg';
import Copy from '../../sprite-svg/copy.svg';
import Creator from '../../sprite-svg/creator.svg';
import Dating from '../../sprite-svg/dating.svg';
import DeleteFile from '../../sprite-svg/delete-file.svg';
import Desktop from '../../sprite-svg/desktop.svg';
import Dislike from '../../sprite-svg/dislike.svg';
import DownloadArrow from '../../sprite-svg/download-arrow.svg';
import Download from '../../sprite-svg/download.svg';
import Earth from '../../sprite-svg/earth.svg';
import Edit from '../../sprite-svg/edit.svg';
import Enter from '../../sprite-svg/enter.svg';
import EyeOff from '../../sprite-svg/eye-off.svg';
import Eye from '../../sprite-svg/eye.svg';
import Fire from '../../sprite-svg/fire.svg';
import Fullscreen from '../../sprite-svg/fullscreen.svg';
import Folder from '../../sprite-svg/folder.svg';
import Friends from '../../sprite-svg/friends.svg';
import Gay from '../../sprite-svg/gay.svg';
import Google from '../../sprite-svg/google.svg';
import Heart from '../../sprite-svg/heart.svg';
import Help from '../../sprite-svg/help.svg';
import HintFilled from '../../sprite-svg/hint-filled.svg';
import Home from '../../sprite-svg/home.svg';
import Image from '../../sprite-svg/image.svg';
import Info from '../../sprite-svg/info.svg';
import LargeMode from '../../sprite-svg/large-mode.svg';
import Like from '../../sprite-svg/like.svg';
import Lock from '../../sprite-svg/lock.svg';
import Login from '../../sprite-svg/login.svg';
import Logout from '../../sprite-svg/logout.svg';
import Magic from '../../sprite-svg/magic.svg';
import Message from '../../sprite-svg/message.svg';
import MicrophoneOff from '../../sprite-svg/microphone-off.svg';
import MicrophoneOn from '../../sprite-svg/microphone-on.svg';
import Minus from '../../sprite-svg/minus.svg';
import Moments from '../../sprite-svg/moments.svg';
import Moon from '../../sprite-svg/moon.svg';
import MoreVertical from '../../sprite-svg/more-vertical.svg';
import Move from '../../sprite-svg/move.svg';
import Mute from '../../sprite-svg/mute.svg';
import News from '../../sprite-svg/news.svg';
import Newest from '../../sprite-svg/newest.svg';
import Nft from '../../sprite-svg/nft.svg';
import NewestVideos from '../../sprite-svg/newest-videos.svg';
import OpenLink from '../../sprite-svg/open-link.svg';
import Pause from '../../sprite-svg/pause.svg';
import Phone from '../../sprite-svg/phone.svg';
import Photo from '../../sprite-svg/photo.svg';
import PhotoOff from '../../sprite-svg/photo-off.svg';
import PlayCircle from '../../sprite-svg/play-circle.svg';
import PlaySmall from '../../sprite-svg/play-small.svg';
import Play from '../../sprite-svg/play.svg';
import PlusCircle from '../../sprite-svg/plus-circle.svg';
import Plus from '../../sprite-svg/plus.svg';
import Post from '../../sprite-svg/post.svg';
import Print from '../../sprite-svg/print.svg';
import Redo from '../../sprite-svg/redo.svg';
import Refresh from '../../sprite-svg/refresh.svg';
import Reload from '../../sprite-svg/reload.svg';
import ReportCheck from '../../sprite-svg/report-check.svg';
import Report from '../../sprite-svg/report.svg';
import RetiredAvatar from '../../sprite-svg/retired-avatar.svg';
import RoundCheck from '../../sprite-svg/round-check.svg';
import SearchAlt from '../../sprite-svg/search-alt.svg';
import SearchCompact from '../../sprite-svg/search-compact.svg';
import Search from '../../sprite-svg/search.svg';
import Send from '../../sprite-svg/send.svg';
import Settings4k from '../../sprite-svg/settings-4k.svg';
import SettingsHd from '../../sprite-svg/settings-hd.svg';
import SettingsVr from '../../sprite-svg/settings-vr.svg';
import Settings from '../../sprite-svg/settings.svg';
import Shield from '../../sprite-svg/shield.svg';
import Sort from '../../sprite-svg/sort.svg';
import Star from '../../sprite-svg/star.svg';
import StartWatching from '../../sprite-svg/start-watching.svg';
import Statistic from '../../sprite-svg/statistic.svg';
import StopWatching from '../../sprite-svg/stop-watching.svg';
import Straight from '../../sprite-svg/straight.svg';
import Sub from '../../sprite-svg/sub.svg';
import Sun from '../../sprite-svg/sun.svg';
import Time from '../../sprite-svg/time.svg';
import Translation from '../../sprite-svg/translation.svg';
import TranslationDisabled from '../../sprite-svg/translation-disabled.svg';
import Trash from '../../sprite-svg/trash.svg';
import Trophy from '../../sprite-svg/trophy.svg';
import Tune from '../../sprite-svg/tune.svg';
import Twitter from '../../sprite-svg/twitter.svg';
import Undo from '../../sprite-svg/undo.svg';
import Unmute from '../../sprite-svg/unmute.svg';
import UploadArrow from '../../sprite-svg/upload-arrow.svg';
import Upload from '../../sprite-svg/upload.svg';
import UserHeader from '../../sprite-svg/user-header.svg';
import VideoOff from '../../sprite-svg/video-off.svg';
import Video from '../../sprite-svg/video.svg';
import Vr from '../../sprite-svg/vr.svg';
import WatchHistory from '../../sprite-svg/watch-history.svg';
import WatchHistoryDisabled from '../../sprite-svg/watch-history-disabled.svg';
import New from '../../sprite-svg/new.svg';
import Story from '../../sprite-svg/story.svg';
import IntroNav from '../../sprite-svg/intro-nav.svg';
import Bell from '../../sprite-svg/bell.svg';
import Bulb from '../../sprite-svg/bulb.svg';
import Edit2 from '../../sprite-svg/edit2.svg';
import Link from '../../sprite-svg/link.svg';
import RoundDollar from '../../sprite-svg/round-dollar.svg';
import File from '../../sprite-svg/file.svg';
import FileUploaded from '../../sprite-svg/file-uploaded.svg';
import ChevronBig from '../../sprite-svg/chevron-big.svg';
import ResumeUpload from '../../sprite-svg/resume-upload.svg';
import AddFriend from '../../sprite-svg/add-friend.svg';
import Chart from '../../sprite-svg/chart.svg';
import Reply from '../../sprite-svg/reply.svg';
import FriendsAccept from '../../sprite-svg/friends-accept.svg';
import Share from '../../sprite-svg/share.svg';
import PaperPlane from '../../sprite-svg/paper-plane.svg';
import ThumbsOn from '../../sprite-svg/thumbs-on.svg';
import Awaiting from '../../sprite-svg/awaiting.svg';
import Hourglass from '../../sprite-svg/hourglass.svg';
import Forbid from '../../sprite-svg/forbid.svg';
import FiledAlert from '../../sprite-svg/filed-alert.svg';
import FieldInfo from '../../sprite-svg/field-info.svg';
import Money from '../../sprite-svg/money.svg';

export const icons = {
    AddVideo,
    Alert,
    AppearanceMobile,
    ArrowDownFilled,
    ArrowDownLong,
    ArrowDownShort,
    Awards,
    BigThumbs,
    BigThumbsDisabled,
    Bisexual,
    Bookmark,
    BurgerMenu,
    Calendar,
    Call,
    Categories,
    Check,
    Clear,
    Close,
    CloseSmall,
    Coins,
    Comments,
    Copy,
    Creator,
    Dating,
    DeleteFile,
    Desktop,
    Dislike,
    DownloadArrow,
    Download,
    Earth,
    Edit,
    Enter,
    EyeOff,
    Eye,
    Fire,
    Fullscreen,
    Folder,
    Friends,
    Gay,
    Google,
    Heart,
    Help,
    HintFilled,
    Home,
    Image,
    Info,
    LargeMode,
    Like,
    Lock,
    Login,
    Logout,
    Magic,
    Message,
    MicrophoneOff,
    MicrophoneOn,
    Minus,
    Moments,
    Moon,
    MoreVertical,
    Move,
    Mute,
    News,
    Newest,
    Nft,
    NewestVideos,
    OpenLink,
    Pause,
    Phone,
    Photo,
    PhotoOff,
    PlayCircle,
    PlaySmall,
    Play,
    PlusCircle,
    Plus,
    Post,
    Print,
    Redo,
    Refresh,
    Reload,
    ReportCheck,
    Report,
    RetiredAvatar,
    RoundCheck,
    SearchAlt,
    SearchCompact,
    Search,
    Send,
    Settings4k,
    SettingsHd,
    SettingsVr,
    Settings,
    Shield,
    Sort,
    Star,
    StartWatching,
    Statistic,
    StopWatching,
    Straight,
    Sub,
    Sun,
    Time,
    Translation,
    TranslationDisabled,
    Trash,
    Trophy,
    Tune,
    Twitter,
    Undo,
    Unmute,
    UploadArrow,
    Upload,
    UserHeader,
    VideoOff,
    Video,
    Vr,
    WatchHistory,
    WatchHistoryDisabled,
    New,
    Story,
    IntroNav,
    Bell,
    Bulb,
    Edit2,
    Link,
    RoundDollar,
    File,
    FileUploaded,
    ChevronBig,
    ResumeUpload,
    AddFriend,
    Chart,
    Reply,
    FriendsAccept,
    Share,
    PaperPlane,
    ThumbsOn,
    Awaiting,
    Hourglass,
    Forbid,
    FiledAlert,
    FieldInfo,
    Money,
} as { [key: string]: IconData };
